var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$i18n.locale == 'en')?_c('SVGQuote'):_c('SVGQuoteFr',{staticClass:"flip"}),_c('div',{staticClass:"quote-underline",style:({backgroundColor: _vm.bgColor})})],1)}
var staticRenderFns = []

export { render, staticRenderFns }